import React from 'react';

const SheetSection = ({label, children}) => {
    return (<section className="SectionContainer-SubSection">
        <h3 className="subTitleSection">{label}</h3>
        {children}
    </section>);
}

export default SheetSection;